import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';

export enum ENUM__generation_output_type {
  /*
   *
   */
  UNKNOWN = 'UNKNOWN',
  /*
   *
   */
  IMAGE = 'IMAGE',
  IMAGE_CONTROL__DEPTH = 'IMAGE_CONTROL__DEPTH',
  IMAGE_CONTROL__CANNY = 'IMAGE_CONTROL__CANNY',
  IMAGE_CONTROL__SOFT_EDGE = 'IMAGE_CONTROL__SOFT_EDGE',
  IMAGE_CONTROL__COLOR_MAP = 'IMAGE_CONTROL__COLOR_MAP',
  IMAGE_CONTROL__MASK = 'IMAGE_CONTROL__MASK',
  /*
   *
   */
  //todo remove
  IMAGE_GENERATION__SD_1 = 'IMAGE_GENERATION__SD_1',
  /*
   *
   */
}

export namespace ENUM_UTILS__generation_output_type {
  export function get_group_image() {
    return [ENUM__generation_output_type.IMAGE];
  }
  export function get_group_image_control() {
    return [
      ENUM__generation_output_type.IMAGE_CONTROL__CANNY,
      ENUM__generation_output_type.IMAGE_CONTROL__SOFT_EDGE,
      ENUM__generation_output_type.IMAGE_CONTROL__COLOR_MAP,
      ENUM__generation_output_type.IMAGE_CONTROL__DEPTH,
    ];
  }

  export function get_type_for_image(category: ENUM__image_asset_category) {
    let out_map = new Map<ENUM__image_asset_category, ENUM__generation_output_type>([
      [ENUM__image_asset_category.ANY, ENUM__generation_output_type.IMAGE],
      [ENUM__image_asset_category.IMAGE, ENUM__generation_output_type.IMAGE],
      [ENUM__image_asset_category.MASK, ENUM__generation_output_type.IMAGE_CONTROL__MASK],
      [ENUM__image_asset_category.COLOR_MAP, ENUM__generation_output_type.IMAGE_CONTROL__COLOR_MAP],
      [ENUM__image_asset_category.LINE__CANNY, ENUM__generation_output_type.IMAGE_CONTROL__CANNY],
      [ENUM__image_asset_category.LINE__SOFT_EDGE, ENUM__generation_output_type.IMAGE_CONTROL__SOFT_EDGE],
      [ENUM__image_asset_category.DEPTH, ENUM__generation_output_type.IMAGE_CONTROL__DEPTH],
    ]);

    let out = out_map.get_or_assert(category);

    return out;
  }
}
